export const TIPOS_ADJUNTOS = Object.freeze({
  GENERAL: "G",
  FACTURAS: "F",
});
